import { TextInput } from 'react-admin';
import TinyMCEInput from '../TinyMCEInput';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArrayDevelopment = ({ index, source, }: { source: string, index: number }) => {
    return (
        <ArrayForm source={source} grid={0}>
            <BoundedInput source={`year_group`} input={<TextInput source="year_group" fullWidth helperText={false} />} />
            <ArrayForm source={'years'} grid={0}>
                <BoundedInput source={`year`} input={<TextInput source="year" fullWidth helperText={false} />} />
                <BoundedInput source={`html_en`} label="Description EN" input={<TinyMCEInput source="dummy" fullWidth helperText={false} sx={{ gridArea: "description_en" }} />} />
                <BoundedInput source={`html_tc`} label="Description TC" input={<TinyMCEInput source="dummy" fullWidth helperText={false} sx={{ gridArea: "description_en" }} />} />
                <BoundedInput source={`html_sc`} label="Description SC" input={<TinyMCEInput source="dummy" fullWidth helperText={false} sx={{ gridArea: "description_en" }} />} />
            </ArrayForm>
        </ArrayForm>
    )
}

export default ArrayDevelopment;